export default "__VITE_PUBLIC_ASSET__e9266648__"